// extracted by mini-css-extract-plugin
export default {"Page":"Terms_Page__74wO+","PageName":"Terms_PageName__UpLs7"};